/*
  Unfazed share button
  - Event delegation on document, so it survives variant re-renders.
  - Uses the native Web Share API when available (mostly mobile).
  - Falls back to copying the product URL to the clipboard with a short confirmation.
*/
(function () {
  function findShareButton(target) {
    return target.closest ? target.closest('[data-unfazed-share]') : null;
  }

  function confirm(btn, message) {
    var original = btn.getAttribute('aria-label') || 'Share';
    btn.setAttribute('aria-label', message);
    btn.classList.add('is-shared');
    setTimeout(function () {
      btn.setAttribute('aria-label', original);
      btn.classList.remove('is-shared');
    }, 2000);
  }

  function copyToClipboard(text, btn) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(
        function () { confirm(btn, 'Link gekopieerd'); },
        function () { window.prompt('Kopieer de link', text); }
      );
    } else {
      window.prompt('Kopieer de link', text);
    }
  }

  document.addEventListener('click', function (event) {
    var btn = findShareButton(event.target);
    if (!btn) return;

    event.preventDefault();

    var url = btn.getAttribute('data-share-url') || window.location.href;
    var title = btn.getAttribute('data-share-title') || document.title;

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {
        /* user cancelled or share failed; do nothing */
      });
    } else {
      copyToClipboard(url, btn);
    }
  });
})();